import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { ToolName } from '../../../cross-team-shared/tools-names';
import { ToolConfig } from '../../../cross-team-shared/tools.config';
import { makeTooltipProvider } from '../toolbar-utils';
import { MainPointCloudToolbarComponent } from './main-point-cloud-toolbar.component';

@Component({
  selector: 'h3-split-view-main-point-cloud-toolbar',
  templateUrl:
    '../abstract-main-toolbar/abstract-main-toolbar-3d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [makeTooltipProvider('right')],
  standalone: false,
})
export class SplitViewMainPointCloudToolbarComponent extends MainPointCloudToolbarComponent {
  protected override buildButtonFromTool(toolConfig: ToolConfig<ToolName>) {
    return {
      ...super.buildButtonFromTool(toolConfig),
      visible$: this.store('selectedTool').$.pipe(
        map((selectedTool) => selectedTool === toolConfig.name),
      ),
    };
  }
}
